import { ActionIcon, Group } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

type PageHeaderProps = {
  title: string;
  hasBack?: boolean;
};

const PageHeader: React.FC<PageHeaderProps> = ({ title, hasBack = false }) => {
  const navigate = useNavigate();
  function navigateToPrevPage() {
    navigate(-1);
  }
  return (
    <Group>
      {hasBack && (
        <ActionIcon variant="subtle" color="gray" aria-label="Settings">
          <IconArrowLeft style={{ width: "80%", height: "80%" }} stroke={1.5} onClick={navigateToPrevPage} />
        </ActionIcon>
      )}
      <h1>{title}</h1>
    </Group>
  );
};
export default PageHeader;
